import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginPage } from '../../components/Auth/LoginPage'

export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => {
    // If already logged in, redirect to campaigns
    if (context.auth?.user) {
      throw redirect({ to: '/campaigns' })
    }
  },
  component: LoginRoute,
})

function LoginRoute() {
  return <LoginPage />
}
